import { gql } from 'apollo-angular';
import { Issue } from '../../entities/issue/issue';

export const ISSUE_QUERY = gql`
query getIssue(
  $id: UUID,
  $commandInputs: [CommandInput]
)
{
  getIssue: getIssue(
    id: $id
  )
  {
    id
    title
    description
    number
    dueDateTime
    commands(commandInputs: $commandInputs)
    issueStatus{
      code
      label
      roles
      color
      statusGroup{
        code
        isOpen
        binaryStatusLabel
      }
    }
    issueType{
      code
      name
      prefix
      icon
      color
    }
    assignee{
      id
      firstName
      lastName
    }
    createdBy{
      id
      firstName
      lastName
    }
    createdDateTime
    lastModifiedDateTime
    aggregationRootId
  }
}
`;


export interface IssueQueryResponse {
  getIssue: Issue;

}
